export default "__VITE_ASSET__DKa_hS9T__"